import axios from 'axios';
import { usePost } from './usePost';
import { cryptojs } from 'helpers';
import { useGET } from './useGet';

function useFetcher() {
    const post = usePost();
    const get = useGET();

    const Omise = (obj: any, omiseBasicAuthenEnc = '') => {
        return new Promise(async (resolve, reject) => {
            axios({
                headers: {
                    'Content-Type': 'application/json',
                    'Referer-Path': window.location.pathname,
                    Authorization: 'Basic ' + cryptojs.decode(cryptojs.decode(cryptojs.decode(omiseBasicAuthenEnc))) + ':',
                },
                method: 'POST',
                url: `https://vault.omise.co/tokens`,
                data: obj,
            })
                .then((res) => res.data)
                .then((json) => resolve(json))
                .catch((error) => {
                    reject(error?.response?.data);
                });
        });
    };

    return {
        POST: post,
        GET: get,
        Omise: Omise,
    };
}

export default useFetcher;
